import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { isPlatformServer } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class BrowserIdService {
  private browserId: string | null = null;

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    this.browserId =
      localStorage.getItem('browser_id') || this.generateBrowserId();
  }

  private generateBrowserId(): string {
    if (isPlatformServer(this.platformId)) {
      return '';
    }
    const newId = crypto.randomUUID();
    localStorage.setItem('browser_id', newId);
    return newId;
  }

  getBrowserId(): Observable<string> {
    return new Observable((observer) => {
      if (this.browserId) {
        observer.next(this.browserId);
      }
      observer.complete();
    });
  }
}